import React from "react";
import { useCart } from "./CartProvider";
import { List, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CartContents = () => {
  const { cartItems, removeFromCart } = useCart();

  if (cartItems.length === 0) {
    return (
      <Typography variant="h6" style={{ marginTop: 20 }}>
        Your cart is empty
      </Typography>
    );
  }

  return (
    <List>
      {cartItems.map((item, index) => (
        <ListItem key={index} divider>
          <ListItemText
            primary={item.name}
            secondary={`${item.description} | Quantity: ${item.quantity} | Price: $${item.price} | ${item.uid}`}
          />
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="delete" onClick={() => removeFromCart(item.uid)}>
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default CartContents;
